export default __webpack_public_path__ + "static/media/persistent-drawer-hover.3e5d5739.gif";